import { formatDisplay } from "../../utils/numberFormat";

function StageCardCount({ count, className }) {
    const display_count = formatDisplay(count);
    const summary_count = "Total Number of Cards"

    if(count === null || count === 0) return null;

    return(
        <span 
            className={`stage-counter ${className}`}
            title={summary_count}
        >
            { display_count }
        </span>
    )
}

export { StageCardCount }